var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { object } from '../../../utils/serializr/serializr';
import { LocationOptions } from './LocationOptions';
import { Actor } from '../../actor/Actor';
import { LocationSteps } from './modules/LocationSteps';
import { LocationStore } from './modules/LocationStore';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { withInit } from '../../../utils/serializr/schema/middle/withInit';
import { LocationGrade } from './modules/LocationGrade';
import { LocationProgress } from './modules/LocationProgress';
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
import { PersistActor } from '../../actor/PersistActor';
export class Location extends PersistActor {
    pathURI = '';
    webClientVersion = 0;
    specials = '';
    json_options; //  = new LocationOptions({ parent: this });
    locationStore;
    constructor(init) {
        super(init);
        editObservable(this);
    }
    get locationSteps() {
        return new LocationSteps(this);
    }
    get locationGrade() {
        return new LocationGrade(this);
    }
    get locationProgress() {
        return new LocationProgress(this);
    }
    get name() {
        const pieces = this.pathname.split('/');
        return pieces[pieces.length - 1] || '';
    }
    set name(n) { }
    pathname_fallback;
    get pathname() {
        return this.pathname_fallback;
    }
    set pathname(pn) {
        this.pathname_fallback = pn;
    }
    get url() {
        return this.locationSteps.pathURIpieces[this.locationSteps.pathURIpieces.length - 1];
    }
    set url(url) {
        this.pathURI = [
            ...this.locationSteps.pathURIpieces.slice(0, this.locationSteps.pathURIpieces.length - 1),
            url,
        ].join('/');
    }
    get pathUrl() {
        return `/${this.pathURI.split('/').slice(1).join('/')}${this.webClientVersion > 0 ? '' : this.type === 'topic' ? '.htm' : '/'}`;
    }
    get locationHref() {
        return this.context.app.appHost.mainHref + this.pathUrl;
    }
    static get serializeInfo() {
        return {
            extends: Actor.serializeInfo,
            props: {
                pathURI: true,
                pathname: true,
                webClientVersion: true,
                bundles: true,
                bundleNames: true,
                packages: true,
                specials: true,
                json_options: withInit(object(LocationOptions), {}),
                locationStore: withInit(object(LocationStore), {}),
            },
        };
    }
}
__decorate([
    editable()
], Location.prototype, "pathURI", void 0);
__decorate([
    editable()
], Location.prototype, "webClientVersion", void 0);
__decorate([
    editable()
], Location.prototype, "specials", void 0);
__decorate([
    editable('ref')
], Location.prototype, "json_options", void 0);
__decorate([
    editable('ref')
], Location.prototype, "locationStore", void 0);
__decorate([
    memoize
], Location.prototype, "locationSteps", null);
__decorate([
    memoize
], Location.prototype, "locationGrade", null);
__decorate([
    memoize
], Location.prototype, "locationProgress", null);
__decorate([
    memoize
], Location, "serializeInfo", null);
